import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AUTH } from "@/constants/testIds";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [msg, setMsg] = useState("Establishing secure session…");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { user } = await api.exchangeSession(session_id);
        setUser(user);
        // Clear hash
        window.history.replaceState(null, "", "/dashboard");
        nav("/dashboard", { replace: true, state: { user } });
      } catch (e) {
        setMsg("Auth failed. Redirecting to login…");
        setTimeout(() => nav("/login", { replace: true }), 1200);
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black text-white">
      <div className="text-center">
        <div className="live-dot mx-auto mb-6" />
        <div data-testid={AUTH.callbackStatus} className="label-xs">{msg}</div>
      </div>
    </div>
  );
}
